// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__IpY2g","canvas":"style_canvas__vFUo1","button":"style_button__Y9iyQ"};